import { Attachment, Send, Clock } from "iconoir-react"
import React from "react"
import { ChangeEvent, KeyboardEvent } from "react"
import MessageInput from "./MessageInput"

interface ChatInputProps {
  message: string
  typing: boolean
  uploading: boolean
  onMessageChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
  onSendMessage: () => void
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  onHeightChange?: (height: number) => void
  onViewHistory?: () => void
}

export default function ChatInput({
  message,
  typing,
  uploading,
  onMessageChange,
  onSendMessage,
  onKeyDown,
  onHeightChange,
  onViewHistory
}: ChatInputProps): React.JSX.Element {
  const disabled = uploading || typing

  const leftButtons = onViewHistory ? (
    <button
      onClick={onViewHistory}
      disabled={disabled}
      className="flex h-[36px] px-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed gap-2 text-sm font-medium"
    >
      <Clock className="w-4 h-4" />
      <span className="hidden sm:inline">History</span>
    </button>
  ) : null

  const rightButtons = (
    <>
      <button
        disabled={disabled}
        id="document-upload"
        className="flex h-[36px] w-[36px] text-white bg-linear-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Attachment id="document-upload-icon" className="w-4 h-4" />
      </button>
      <button
        className="flex h-[36px] w-[36px] text-white bg-linear-to-r from-green-400 to-green-500 hover:from-green-500 hover:to-green-600 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={onSendMessage}
        disabled={disabled}
      >
        <Send className="w-4 h-4" />
      </button>
    </>
  )

  return (
    <MessageInput
      message={message}
      placeholder="Send a message."
      disabled={disabled}
      onMessageChange={onMessageChange}
      onKeyDown={onKeyDown}
      onHeightChange={onHeightChange}
      leftButtons={leftButtons}
      rightButtons={rightButtons}
    />
  )
}
